import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'describe_concerns_difficulties_questions_listed_this_section_7'

export const dataPointDefinition = {
  retracedId: 'describe_concerns_difficulties_questions_listed_this_section_7',
  name: 'Please describe any concerns or difficulties with questions listed in this section:',
  description:
    'Leave this blank if you did not have any difficulties with answering the above questions and you do not have any concerns about the above questions. ',
  meta: {
    slcpMeta: {
      key: 'wi-fac-1',
      number: 'WI-FAC-1',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wi-fac-1', version: '1.7.0', provider: 'slcp'}],
  sortingId: 36600,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
